import React from 'react';

import { Idle, MainEngineNotStarted } from 'screens/shared';
import DieselMainEngineStarted from './DieselMainEngineStarted';

const DieselIdle = () => {
  const components = [
    MainEngineNotStarted,
    DieselMainEngineStarted
  ];

  return <Idle components={components} />;
};

export default DieselIdle;



// WEBPACK FOOTER //
// ./src/screens/Diesel/DieselIdle/DieselIdle.js